import { type } from 'arktype';

/**
 * Contrato de la respuesta de `GET /api/health`.
 * Lo valida el backend a la salida (test) y el frontend a la entrada (useHealth):
 * es la prueba vertical del scaffold de que common gobierna la frontera API.
 */
export const healthResponseSchema = type({
	// Estado de la base de datos: 'up' si responde a una consulta trivial, 'down' si falla.
	// Un 'down' NUNCA se traduce en un error HTTP: el endpoint sigue devolviendo 200 (CA-01.13).
	db: "'up'|'down'",
	status: "'ok'",
	// Instante de la respuesta en ISO 8601 (UTC)
	timestamp: 'string.date.iso',
});

export type HealthResponse = typeof healthResponseSchema.infer;
